// components/Footer.js
import React from "react";
import "./Footer.css";

const Footer = () => {
  // Smooth scroll handler
  const handleScroll = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <h3>KadaiPOS</h3>
            <p>
              Revolutionizing retail with cutting-edge point of sale solutions
              designed to help your business grow.
            </p>
          </div>

          {/* Product Links */}
          <div className="footer-section">
            <h4>Product</h4>
            <a href="#features" onClick={(e) => handleScroll(e, "features")}>
              Features
            </a>
            <a href="#pricing" onClick={(e) => handleScroll(e, "pricing")}>
              Pricing
            </a>
            <a
              href="#testimonials"
              onClick={(e) => handleScroll(e, "testimonials")}
            >
              Testimonials
            </a>
            <a href="#faq" onClick={(e) => handleScroll(e, "faq")}>
              FAQ
            </a>
          </div>

          {/* Support Links */}
          <div className="footer-section">
            <h4>Support</h4>
            <a href="#help" onClick={(e) => handleScroll(e, "help")}>
              Help Center
            </a>
            <a href="#contact" onClick={(e) => handleScroll(e, "contact")}>
              Contact Us
            </a>
            <a href="#docs" onClick={(e) => handleScroll(e, "docs")}>
              Documentation
            </a>
            <a href="#community" onClick={(e) => handleScroll(e, "community")}>
              Community
            </a>
          </div>

          {/* Company Links */}
          <div className="footer-section">
            <h4>Company</h4>
            <a href="#about" onClick={(e) => handleScroll(e, "about")}>
              About Us
            </a>
            <a href="#careers" onClick={(e) => handleScroll(e, "careers")}>
              Careers
            </a>
            <a href="#blog" onClick={(e) => handleScroll(e, "blog")}>
              Blog
            </a>
            <a href="#Phone" onClick={(e) => handleScroll(e, "press")}>
              Ph- (+91 8124888145)
            </a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <p>
            &copy; 2025 KadaiPOS. All rights reserved. | Privacy Policy | Terms
            of Service
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
